/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { func, number, string } from 'prop-types'

import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Textbox from '@taglivros/oef_componentes/build/components/textbox'

import { usePromocao } from '../../contexts/PromocaoContext'
import { ID_CUPOM_PROMOCAO, LABEL_CUPOM_PROMOCAO, TITULO_CUPOM_PROMOCAO } from './constantsPromocao'
import { BOTAO_CONFIRMAR } from '../../components/CVVInput/constantsCVVInput'
import { empty, isEmptyObject, handleKeyPressCaracteresEspeciais } from '../../utils/helpers/helpers'
import { useGlobal } from '../../contexts/GlobalContext'

const WrapperCupomPromocaoInput = styled.div`
  margin-top: 30px;
  position: relative;

  & label {
    z-index: 0;
  }

  & button {
    width: auto;
  }

  h4 {
    ${StyleGuide.tipografia.textoDefault}
    ${StyleGuide.boldFonte}
    margin-bottom: 20px;
  }
`

const CupomPromocaoInput = ( { formaPagamento, idAssinatura, idPlano, onConfirmar, promocaoExterna, tipoAssinatura, email } ) => {
  const {
    codigoPromocao,
    dadosPromocao,
    deleteDadosPromocao,
    errosPromocao,
    promocaoDeletada,
    setCodigoPromocao,
    validarCodigoPromocao,
  } = usePromocao()
  const {
    urlParameters,
  } = useGlobal()
  const [ erros, setErros ] = useState( { } )
  const [ state, setState ] = useState( { 'cupom-promocao': getDefaultCoupon() } )
  const [ sucesso, setSucesso ] = useState( false )
  const [ requisitosPromocao, setRequisitosPromocao ] = useState( false )
  const [ ultimaTentativaCupom, setUltimaTentativaCupom ] = useState( '' )

  function getDefaultCoupon() {
    const defaultCoupon = urlParameters.coupon
    return defaultCoupon ? defaultCoupon : ''
  }

  useEffect( () => {
    if ( isEmptyObject( state ) && isEmptyObject( erros ) ) {
      deleteDadosPromocao( false )
    }
  }, [ erros, state ] )

  useEffect( () => {
    if ( ( idAssinatura === 0 || idAssinatura ) && idPlano && formaPagamento && tipoAssinatura ) {
      setRequisitosPromocao( true )
    }
  }, [ idAssinatura, idPlano, formaPagamento, tipoAssinatura ] )

  useEffect( () => {
    const isPromocaoValida = errosPromocao === ''

    if ( !isEmptyObject( dadosPromocao ) && empty( errosPromocao ) ) {
      onConfirmar( {
        'codigo': state[ ID_CUPOM_PROMOCAO ] || codigoPromocao,
        isPromocaoValida
      } )
    } else if ( promocaoExterna && !empty( errosPromocao ) ) {
      onConfirmar( {
        'codigo': '',
        isPromocaoValida
      } )
    }
  }, [ dadosPromocao, errosPromocao, promocaoExterna ] )

  useEffect( () => {
    if ( promocaoDeletada ) {
      setState( {} )
      setErros( {} )
      setSucesso( false )
      setCodigoPromocao( '' )
      onConfirmar( {
        'codigo': '',
        'isPromocaoValida': false
      } )
    }
  }, [ onConfirmar, promocaoDeletada ] )

  useEffect( () => {
    if ( !empty( errosPromocao ) ) {
      setErros( {
        ...erros,
        [ ID_CUPOM_PROMOCAO ]: errosPromocao
      } )

      setSucesso( false )
    }
  }, [ errosPromocao ] )

  useEffect( () => {
    if ( promocaoExterna && requisitosPromocao && !sucesso ) {
      validarCodigoPromocao( idAssinatura, idPlano, promocaoExterna, formaPagamento, tipoAssinatura, email )
    }

    if ( ultimaTentativaCupom !== promocaoExterna ) {
      setUltimaTentativaCupom( promocaoExterna )
      setCodigoPromocao( promocaoExterna )
    }
  }, [ promocaoExterna, requisitosPromocao ] )

  useEffect( () => {
    if ( !empty( codigoPromocao ) ) {
      setState( {
        [ ID_CUPOM_PROMOCAO ]: codigoPromocao
      } )

      setSucesso( true )
    }
  }, [ codigoPromocao ] )

  const handleBlurCupomPromocao = event => {
    const { name, value } = event.target

    if ( empty( value ) ) {
      return setSucesso( false )
    }

    setErros( { [ ID_CUPOM_PROMOCAO ]: null } )

    if ( onConfirmar && isEmptyObject( erros ) && !isEmptyObject( state ) && requisitosPromocao ) {
      validarCodigoPromocao( idAssinatura, idPlano, state[ name ], formaPagamento, tipoAssinatura, email )
      setSucesso( true )
    }
  }

  useEffect( () => {
    if ( state[ 'cupom-promocao' ]?.length > 0 ) {
      validarCodigoPromocao( idAssinatura, idPlano, state[ 'cupom-promocao' ], formaPagamento, tipoAssinatura, email )
    }
  }, [] )

  const handleChangeCupomPromocao = event => {
    const { name, value } = event.target
    setState( {
      ...state,
      [ name ]: value.toUpperCase().trim()
    } )

    if ( sucesso ) {
      setSucesso( false )
    }

    if ( !isEmptyObject( erros ) ) {
      setErros( { [ name ]: null } )
    }
  }

  return (
    <WrapperCupomPromocaoInput>
      <h4>{ TITULO_CUPOM_PROMOCAO }</h4>

      <Textbox
        buttonValue={ BOTAO_CONFIRMAR }
        erro={ erros[ ID_CUPOM_PROMOCAO ] }
        label={ LABEL_CUPOM_PROMOCAO }
        name={ ID_CUPOM_PROMOCAO }
        onBlur={ handleBlurCupomPromocao }
        onChange={ handleChangeCupomPromocao }
        onKeyPress={ handleKeyPressCaracteresEspeciais }
        sucesso={ sucesso }
        tipo="text"
        value={ state[ ID_CUPOM_PROMOCAO ] }
      />
    </WrapperCupomPromocaoInput>
  )
}

CupomPromocaoInput.defaultProps = {
  'onConfirmar': null,
  'promocaoExterna': null
}

CupomPromocaoInput.propTypes = {
  'email': string.isRequired,
  'formaPagamento': string.isRequired,
  'idAssinatura': number.isRequired,
  'idPlano': string.isRequired,
  'onConfirmar': func,
  'promocaoExterna': string,
  'tipoAssinatura': string.isRequired
}

export default CupomPromocaoInput
